<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Cycling in Chicago</title>
<link href="css/9781439663394.css" rel="stylesheet" type="text/css"/>
<p class="c_13" id="Ack"><a id="pg7">A<span class="small">CKNOWLEDGMENTS</span></a></p><a id="pg7">
<p class="noindent">I am very grateful to the many people and organizations that provided materials and support for this book, like Oscar Wastyn Jr. and his son Scott Wastyn. The Wastyns gave me access to their tremendous archive of cycling photographs, newspaper clippings, and memorabilia. The Wastyn family has owned and operated Chicago’s Oscar Wastyn Cycles for over 100 years.</p>
<p class="indent">Thank-yous go to Ron Burke and Ted Villaire of the Active Transportation Alliance for sharing their photographs and providing the preface of the book; Jeff Ruetsche of Arcadia Publishing for his patience; the US Bicycling Hall of Fame in Davis, California; Ben Helphand at the Friends of the Bloomingdale Trail; Randy Neufeld of SRAM for his early advice, insight, and guidance; the Kozy family; Turin Bicycles; Heritage Bicycles; the South Chicago Wheelmen; Steve Buchtel of Trails for Illinois; and Julia Bachrach at the Chicago Park District.</p>
<p class="indent">Thanks also go to the George Garner family for providing photographs of George Garner Cyclery, North Central College for allowing me access to its tremendous Illinois Prairie Path archives, Suzie LaBelle of the Evanston Bike Club, John Kline of the Kenosha Velodrome, Joe Beemster of the Wheeling Wheelmen, Tracy Dangott of XXX Racing-Athletico, Richard Schwinn of Waterford Bikes (thanks for the factory tour!), Sharon Budde for her great suggestions and advice, and finally my wife, Mina, for her support and patience.</p>
<p class="indent">Images without a parenthetical credit line are from the author’s collection.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_acknowledgement.vue?45234fb4